import React from 'react';
import IsValidComponent from './validate-input';
import { IFormikInput } from '../../../models/components/input-formik';
import { getIn } from 'formik';

const Input = (props: IFormikInput) => {
    return (
        <div className={props.className ? props.className : 'form-input form-group'}>
            {(props.name === 'oldPassword' || props.name === 'newPassword' || props.name === 'confirmNewPassword') && props.render ? props.render : null}
            <input
                name={props.name}
                id={props.name}
                onBlur={props.formik.handleBlur}
                onChange={props.onChange ? (e: any) => props.onChange(e, props.formik) : props.formik.handleChange}
                value={props.value ? props.value : getIn(props.formik.values, props.name)}
                required={props.required ?? false}
                type={props.type}
                max={props.max}
                min={props.min}
                disabled={props.disable ? props.disable : false}
                onKeyUp={props.onKeyUp}
                onKeyDown={(e) => {
                    if (props.noSpace && e.key === ' ') {
                        e.preventDefault();
                    }
                    if (["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter"].includes(e.key)) {
                        return;
                    }
                    if (props.noLetters && e.key.match(/[a-zA-ZğüşıöçĞÜŞİÖÇ]/)) {
                        e.preventDefault();
                    }
                
                    if (props.onKeyDown) {
                        props.onKeyDown(e);
                    }
                }}
                className={props.inputClass ? props.inputClass : ''}
                style={{
                    marginBlockStart:'30px'
                }}
            />


            <span className="highlight" />
            <span className="bar" />
            <label  htmlFor={props.name}>{props.placeHolder ? props.placeHolder : ''}</label>
            <IsValidComponent name={props.name} value={props.value ? props.value : getIn(props.formik.values, props.name)} isSubmitting={props.formik.submitCount} errors={getIn(props.formik.errors, props.name)} touched={getIn(props.formik.touched, props.name)} />
            {props.label ? <label >{props.label}</label> : null}
            {(props.name !== 'oldPassword' && props.name !== 'newPassword' && props.name !== 'confirmNewPassword') && props.render ? props.render : null}
        </div>
    );
};

export default Input;